//import { useRecorder } from "voice-recorder-react";
import React,{ useEffect, useRef, useState } from "react";
import AudioPlayer from './AudioPlayer'

import {FaPlay,FaPause,FaMicrophone} from 'react-icons/fa'
import {BiSquareRounded} from 'react-icons/bi'
import {HiOutlineUpload} from 'react-icons/hi'


import d9 from './RecorderHooks.module.css'
import MicRecorder from "mic-recorder-to-mp3";
import { BsXLg } from "react-icons/bs";
// Recorder Hook component
export default function RecorderHooks(props) {
  const [sent, setSent] = useState(false);
  
 


  const recorder = useRef(null); //Recorder
  const audioPlayer = useRef(null); //Ref for HTML Audio tag
  
  const timer = useRef(); //Ref for interval object
  const time = useRef(0); //Stores the value of time
  const displayTime = useRef({}); //Stores dom ref for div to be used to display time

  const [BlobObject, setBlobObject] = useState(null);
  const [isRecording, setIsRecording] = useState(null);
  
  useEffect(() => {
    //Declares the recorder object and stores it in ref
    recorder.current = new MicRecorder({ bitRate: 128 });
  }, []);

  const startRecording = () => {
    //start() returns a promise incase if audio is not blocked by browser
    recorder.current.start().then(() => {
      setIsRecording(true);
      setBlobObject(null)
    });
  };

  const stopRecording = () => {
    recorder.current
      .stop()
      .getMp3()
      .then(([buffer, blob]) => {
        clearInterval(timer.current)
        setBlobObject(blob); //refreshes the page
        setIsRecording(false);
      })
      .catch((e) => console.log(e));
  };


  const cancelRecording = () => {
    recorder.current.stop()
    setIsRecording(false);
        setBlobObject(null); //refreshes the page
        clearInterval(timer.current)
     
  };



  useEffect(() => {
    //start/stops timer depending on recording state
    if (isRecording) {
      startTimer();
    } else {
      stopTimer();
    }
  }, [isRecording]);


  const startTimer = () => {
    //sets interval that updates time on UI every second
    time.current = 0;
    timer.current = setInterval(() => {
      time.current = time.current + 1;
      displayTime.current.innerText = formatTime(time.current);
      //Displays time by updating the DOM directly
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(timer.current);
  };

  function formatMinutes(minutes) {
    return minutes < 10 ? `0${minutes}` : minutes;
  }

  function formatSeconds(seconds) {
    return seconds < 10 ? `0${seconds}` : seconds;
  }

  function formatTime(currentTime=0){
   return (formatMinutes((currentTime / 60).toFixed(0)) + ":" +
            formatSeconds((currentTime % 60).toFixed(0))) 

  }




  return (
    <div className={d9.recordingContainer}>
    <div className={d9.content}> 



{isRecording &&<>
      <button className={d9.cancelButton} type="button" onClick={cancelRecording}>{<BsXLg/>}</button>


<p className={d9.duration} ref={displayTime}>00:00</p>
          </>
        }
     {isRecording ? 
     
      <button className={d9.recordButton}  type="button" onClick={stopRecording}>
        <BiSquareRounded/>
      </button>
      :
      <button className={d9.recordButton}  type="button" onClick={startRecording}>
      <FaMicrophone/>
      </button>
    }

   
      {BlobObject && (
        <>
          
          <button  className={d9.downloadButton} id={sent?d9.sent:d9.notSent} type="button" onClick={()=>{props.getBolb(BlobObject);console.log('blob',BlobObject);setSent(true);}}>{<HiOutlineUpload/>|| 'submit'}</button> 
     
        </>        
      )}
      
     
    </div>

    {BlobObject && (
        <>
         
          <AudioPlayer color={'grey'} background={'#fff'} progressColor={'rgb(12, 153, 255)'}  src={URL.createObjectURL(BlobObject)}/>
        </>        
      )}
      
</div>
  );
}
